import type { WorkspaceEntitlements } from "@/packages/domains/billing";
import { useBilling } from "./useBilling";
import { useFeatureFlags } from "./useFeatureFlags";

export function useEntitlements() {
  const { entitlements, tier } = useBilling();
  const { isDemo } = useFeatureFlags();

  if (isDemo)
    return {
      canCreateAudit: () => true,
      canInviteMembers: () => true,
      requiresUpgrade: () => false,
    };

  return {
    canCreateAudit: (currentCount: number) =>
      isDemo ||
      entitlements.maxAudits === "unlimited" ||
      currentCount < entitlements.maxAudits,
    canInviteMembers: (currentCount: number) =>
      isDemo ||
      entitlements.maxMembers === "unlimited" ||
      currentCount < entitlements.maxMembers,
    requiresUpgrade: (feature: keyof WorkspaceEntitlements) =>
      !isDemo &&
      typeof entitlements[feature] === "boolean" &&
      !entitlements[feature],
    isDemo,
    tier,
  };
}
